(function () {
  document.documentElement.classList.add('ws-motion-enabled');

  var revealObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  document.querySelectorAll('[data-ws-reveal]').forEach(function (el) {
    revealObserver.observe(el);
  });

  function easeOutQuad(t) {
    return t * (2 - t);
  }

  // toLocaleString gives us "13,749"-style thousand separators for free,
  // and leaves small numbers (72, 234, 18...) untouched — same call works
  // for every figure on the site regardless of magnitude.
  function formatCount(n) {
    return n.toLocaleString('en-GB');
  }

  var countObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);

        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-ws-count-to'));
        var suffix = el.getAttribute('data-ws-count-suffix') || '';
        var duration = 1100;
        var start = null;

        function step(timestamp) {
          if (start === null) start = timestamp;
          var progress = Math.min((timestamp - start) / duration, 1);
          el.textContent = formatCount(Math.round(target * easeOutQuad(progress))) + suffix;
          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            el.textContent = formatCount(target) + suffix;
          }
        }
        window.requestAnimationFrame(step);
      });
    },
    { threshold: 0.6 }
  );

  document.querySelectorAll('[data-ws-count-to]').forEach(function (el) {
    countObserver.observe(el);
  });

  // Non-numeric figures (e.g. "Uncapped") that sit alongside counters in the
  // same row — nothing to count, but they should still pop in at the same
  // scroll-triggered moment so the row animates as one unit.
  var popObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.6 }
  );

  document.querySelectorAll('[data-ws-pop]').forEach(function (el) {
    popObserver.observe(el);
  });
})();
